import * as React from "react";
const SvgPause = props => <svg xmlns="http://www.w3.org/2000/svg" width={12} height={12} viewBox="0 0 12 12" {...props}><path fill="currentColor" d="M5 10H2V2h3zM10 10H7V2h3z" /></svg>;
export default SvgPause;